<template>
<md-table-row>
  <md-table-cell>
    {{ value.name }}
  </md-table-cell>
  <md-table-cell>
    <country-select
        mdClearable
        v-model="value.country_iso3"
    ></country-select>
  </md-table-cell>
  <md-table-cell class="email-offers">
    <div class="md-field md-focused">
      <label>Emails offers</label>
      <input-tag
          placeholder="Add email"
          v-model="value.offers_emails"
          validate="email"
          class="md-input h-auto celda-scroll"
      ></input-tag>
    </div>
  </md-table-cell>
  <md-table-cell>
    <div class="md-field md-focused">
      <label>Emails restrictions</label>
      <input-tag
          placeholder="Add email"
          v-model="value.restriction_emails"
          validate="email"
          class="md-input h-auto celda-scroll"
      ></input-tag>
    </div>
  </md-table-cell>
  <md-table-cell>
    <segment-select
        mdClearable
        v-model="value.online_wavy_segment_id"
    ></segment-select>
  </md-table-cell>
  <md-table-cell>
    <segment-select
        mdClearable
        v-model="value.offline_wavy_segment_id"
    ></segment-select>
  </md-table-cell>
  <md-table-cell>
    <channel-select
        mdClearable
        :online="false"
        v-model="value.offline_channel_id"
    ></channel-select>
  </md-table-cell>
  <md-table-cell>
    <channel-select
        mdClearable
        :online="true"
        v-model="value.online_channel_id"
    ></channel-select>
  </md-table-cell>
</md-table-row>
</template>

<script>
import InputTag from "vue-input-tag";

import ChannelSelect from "../../../../components/Inputs/ChannelSelect.vue";
import CountrySelect from "../../../../components/Inputs/CountrySelect.vue";
import SegmentSelect from "../../../../components/Inputs/SegmentSelect.vue";

export default {
  name: "AgencyRow",
  components: {
    InputTag,
    CountrySelect,
    ChannelSelect,
    SegmentSelect
  },
  props: {
    value: Object,
  },
};
</script>

<style lang="scss">
.celda-scroll {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  max-height: 70px !important;
}
</style>
